<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Attendance Report Progress</li>
      </ol>
    </div>
    <div class="attendance-report">

      <div class="tab-content ">
        <div id="inf-month" class="tab-pane fade show active">
          <div class="emp-time-table">
          <div>
              <div class="add-new-section">
                <span class="w-tag">W 42</span>
              <div class="tbl-body col-one">
                <span class="w-tag">W 42</span>
                <div class="time-head">
                  <div class="tbl-td"><span class="add-emp"> Employees</span></div>
                </div>
                <div class="time-head point-head">
                    <ul class="nav nav-tabs nav-fill time-tabs" role="tablist">
                      <li class="nav-item">
                        <span class="tm-text">Time</span>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#min" role="tab" aria-controls="min" aria-selected="true">30 min</a>
                        <a class="nav-link " data-toggle="tab" href="#hr" role="tab" aria-controls="hr" aria-selected="false">1 hr</a>
                      </li>
                    </ul>
                    <!-- <div class="tab-content mt-3"><div class="tab-pane active" id="duck" role="tabpanel" aria-labelledby="duck-tab"></div><div class="tab-pane" id="chicken" role="tabpanel" aria-labelledby="chicken-tab"></div></div> -->
                </div>

                <div class="tbl-row m-5" v-for="employee in attendanceEmployees.attendanceEmployeesTime">
                  <div class="tbl-td">
                    <div class="empl-info">
                      <div class="avtar">
<!--                        <a href="#">-->
<!--                          <img src="https://stagingapipavagt.6lgx.com/storage/thumbnails/ugkHKv8SHaGGFgpfSqCCzpinhco5jcanK6OnVYEw.jpg" alt="Profile image" width="50" height="50">-->
<!--                        </a>-->

                          <img
                            :src="$API_URL+'storage/'+employee.image"
                            alt="Profile image"
                            width="80"
                            height="80"
                            v-if="employee.image !== ''"
                          />
                          <span v-if="employee.image === ''" class="profile-name text-uppercase mt-10 ml-5">
                                    {{ getNameFirstLetter2(employee.name,'F1') }}
                                  </span>


                      </div>
                      <div class="empl-descrip">
                        <strong class="emp-name text-capitalize">
                          <router-link :to="'/employee/profile/'+employee.uuid">{{ employee.name }}</router-link>
<!--                          <small v-for="jobRole in employee.jobRoles">
                            <i class="ico ico-fill-circle" :style="'color:'+jobRole.detail.color "></i>{{ jobRole.detail.name }}
                          </small>-->
                          <small >
                            <i class="ico ico-fill-circle" :style="'color:'+(employee.jobRoles !=='')?employee.jobRoles[0].detail.color:'' "></i>{{ (employee.jobRoles !=='')?employee.jobRoles[0].detail.name:'' }}
                          </small>
                        </strong>

<!--                        <div class="emp-designation">
                          <span v-for="jobRole in employee.jobRoles">
                            <i class="ico ico-fill-circle" :style="'color:'+jobRole.detail.color "></i>{{ jobRole.detail.name }}
                          </span>
                        </div>-->
                      </div>
                    </div>
<!--                    <ul class="emp-time-list">
                      <li v-for="attendance in employee.attendances" v-if="attendance.punch_out_time"> {{getcalculateHourMinutes(attendance.punch_in_time,attendance.punch_out_time,attendance.punch_in_time)}}</li>
                      <li v-else>0h</li>
                    </ul>-->
                  </div>
                </div>
              </div>

              <!-- body 2 -->
                <div class="tbl-body col-two over-x-scroll " >
<!--                  <div class="moving-bar">
                    <span class="red-dot"></span>
                  </div>-->
                    <div class="table-head">
                      <div class="time-head timeHead">
                        <div class="tbl-td" v-for="hour in timesArray">
<!--                          <pre ><code>{{ hour.minutesArray  }}</code></pre>-->
                          <span class="inner-box">
                            <time datetime="" class="clck-time" >{{ hour }}</time>
                          </span>
                          <span class="inner-box"></span>
                        </div>
                      </div>
                      <div class="time-head point-head">
                       <div class="tbl-td" v-for="hour in timesArray">
                          <span class="inner-box"></span>
                        </div>
<!--                       <div class="tbl-td">
                          <span class="inner-box">1</span>
                          <span class="inner-box">1</span>
                        </div>-->

                      </div>
                    </div>
                    <!-- ------------------------------------------ -->
                    <div class="tbl-row m-5" v-for="(attendanceEmp,key) in attendanceEmployees.attendanceEmployeesTime">
<!--                      <div style="background: white" v-for="(hour,hourKey) in timesArray"
                           v-if="attendanceEmp.attendances !='' && checkAttendance(hour,attendanceEmp.attendances[0].punch_in_time,attendanceEmp.attendances[0].punch_out_time)">
                        <div class="tbl-td active"
                             :style="'background:'+attendanceProgressColor(attendanceEmp.attendances[0].punch_in_time,attendanceEmp.attendances[0].punch_out_time)+';'+'border:'+attendanceProgressColor(attendanceEmp.attendances[0].punch_in_time,attendanceEmp.attendances[0].punch_out_time)+';opacity: 0.5;margin-left:'+marginLeft"
                              >
                          <span class="inner-box" >{{attendanceEmp.attendances[0].punch_in_time}}</span>
                          <span class="inner-box" ></span>
                        </div>
                      </div>-->

                      <div v-for="(hour,hourKey) in timesArray"
                           :class="{'shiftStartButNotAttendance':AddClasscheckAttendance(attendanceEmp,hour)}"
                           v-if="attendanceEmp !=='' && checkAttendance(attendanceEmp,hour)">

                          <div class="tbl-td active"
                               :style="'background:'+attendanceProgressColor(attendanceEmp,hour)+';'+
                             'border:'+attendanceProgressColor(attendanceEmp,hour)+
                             ';opacity: 0.5;margin-left:'+marginLeft">
                          <span class="inner-box" ></span>
                          <span class="inner-box" ></span>
                        </div>
                      </div>
                      <div v-else style="background: white">
                        <div class="tbl-td">
                          <span class="inner-box" ></span>
                          <span class="inner-box" ></span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker'
  export default {
    components: {
      DatePicker,
    },
    data() {
      return {
        borderColor:'red',
        bgColor:'green',
        users: [],
        users2: [],
        employees: [],
        attendanceEmployees: [],
        timesArray: [],
        roleColor: '',
        company_id: this.$store.getters.getSelectedCompany.id,
        currentTime: moment().format('HH:mm'),
        currentDateTime: moment().format('YY-MM-DD HH:MM:SS'),
        marginLeft:0
      }
    },
    created() {
      this.weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      this.calculateHours();
      this.getAttendanceEmployees();
    },
    mounted() {

    },
    methods: {

      activeClassByCurrentDate(punchIn){
        if( moment(punchIn).format('YY-MM-DD')=== moment().format('YY-MM-DD')){
          return true;
        }else{
          return false;
        }
      },
      calculateHours(){
        for (let i = 0; i <= 23 + 1; i++) {
          var val='';
          if(i<10){
            val='0'+i;
          }else{
            val=i;
          }
          // this.timesArray.push(val+':00',val+':15',val+':30',val+':45');
          this.timesArray.push(val+':00');
        }
      },
      attendanceProgressColor(data,hour){
        if(data.attendances[0] !='') {
          if (data.attendances[0].punch_in_time != '' && data.attendances[0].punch_out_time === null) {
            return 'rgb(0 128 0 / 63%)';
          }
        }
      },
      checkAttendance(data,hour){
        if(data.attendances[0] !='' && data.attendances[0] !==undefined ){
          if(this.AddClasscheckAttendance(data,hour) ){
            return true;
          }else{
            if((hour >= moment(data.attendances[0].punch_in_time).format('hh:mm') &&
                hour <= this.currentTime && data.attendances[0].punch_out_time ==null) ||
              (hour >= moment(data.attendances[0].punch_in_time).format('hh:mm')  &&
                data.attendances[0].punch_out_time !=null &&
                hour < moment(data.attendances[0].punch_out_time).format('HH:MM')) ){
              // if((hour > key && hour < this.currentTime ) ){
              return true;
            }else{
              return false;
            }
          }
        }

      },
      AddClasscheckAttendance(data,hour){

       // console.log(data.schedules[0],'asdasdasd das');
          if (( (hour >= moment(data.attendances[0].schedule.date + ' ' + data.attendances[0].schedule.start_time).format('HH:mm')) &&
            (hour < moment(data.attendances[0].schedule.date + ' ' + data.attendances[0].schedule.end_time).format('HH:mm')) &&
            (hour < moment(data.attendances[0].punch_in_time).format('HH:mm')))) {
           // console.log('sdsdsd');
            return true;
          } else {
            return false;
          }

      },
      getAttendanceEmployees(){
        let params = {company_id:this.company_id,date:moment().format('YYYY-MM-DD')}
        this.$axios
          .get(this.$GetAttendanceEmployee, {
            params: params,
            headers: this.getAuthHeader()
          })
          .then(response => {
            this.attendanceEmployees = response.data.result || []
            this.employees = this.attendanceEmployees.employees
          //  console.log(this.attendanceEmployees);
          })
          .catch(error => {
          //  console.log(error);
          })
      },
      getNameFirstLetter2(name,tp){
        return this.getNameFirstLetter(name);
      },
      getcalculateHourMinutes (startTime,endTime,date){

        if(endTime !=''){

        var time= this.calculateHourMinutes2(moment(startTime).format('hh:mm'),moment(endTime).format('hh:mm'),moment(date).format('YY-MM-DD'));
          if(time =='Invalid date'){
            return 0+'h';
          }else{
            return time;
          }

        }else{
          return  0;
        }

      },
    filterByJobType(id, color, name) {
      let tagNam = $('.roleName')[0];
      tagNam.innerText = name;
      this.roleColor = color;
      this.users = this.users2;
      this.users = this.users.filter((item) => {
        if (item.roleTypeIds.includes(id)) {
          return item;
        }
      });
    },
    allEmployeeAfterFilter() {
      $('.roleName')[0].innerText = 'Select job type';
      this.roleColor = '';
      this.users = this.users2;
    },

    scrollX(e) {
      this.$refs['scroll_container'].scrollLeft += e.deltaY;
    },
  }
  }

</script>

<style scoped>

  .report-table .empl-info .avtar {
    position: relative;
  }

  .profile-name {
    position: absolute;
    top: -1px;
    left: 8px;
    font-size: 9px;
  }

  .emp-time-table .empl-info .emp-name{
    line-height: 1.8rem !important;
    margin-bottom: 0px !important;
  }
  .emp-time-table .tbl-row .tbl-td{
    min-height: 30px !important;
  }
  .emp-time-table .tbl-row .tbl-td .inner-box{
    width: 21.5px;
  }
  .emp-time-table .time-head .tbl-td .inner-box{
    width: 16px;
  }
  .tbl-row >div:first-child .tbl-td .inner-box:first-child{
    /*width: 0;*/
    /*width: 21.5px;*/
    width: 10.5px;
  }
  .emp-time-table .time-head .tbl-td .clck-time{
    right: -15px;
  }
  .timeHead .time-head .tbl-td:first-child{
    display: none !important;
  }

  .emp-time-table .add-new-section .col-one{
    flex-shrink: 0;
    width: 341px !important;
  }
  .emp-time-table .add-new-section .col-one .tbl-td{
    min-width: 339px !important;
    padding: 0px 5px !important;
  }
  .emp-time-table .emp-time-list li {
    padding: 0 5.5px !important;
  }
  .emp-time-table .empl-info .avtar{
    width: 29px !important;
    height: 29px !important;
  }
  .emp-time-table .add-new-section{
    max-width: 1422px;
    background: #fff;
  }
  .emp-time-table .add-new-section .w-tag{
    right: 0;
  }
  .emp-time-table .add-new-section:after{
    right: 26px;
  }
  .shiftStartButNotAttendance{
    background: red;
  }
</style>
